// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__WDIOr"};
module.exports.__checksum = "61928127deb3"
